export enum RenewablesRoutingSubRoutes {
  EUR = 'EUR',
  NA = 'NA',
  MAPS = 'maps',
}
